import React, { FunctionComponent } from 'react';
import { Box, BoxProps, Typography } from '@mui/material';
import { Done as DoneIcon, DoneAll as DoneAllIcon } from '@mui/icons-material';

import { IMessage } from '../../../../../store/V2/ChatSlice';
import { useAppSelector } from '../../../../../hooks';
import { getAuthState } from '../../../../../store/AuthSlice';
import { TP_COLORS } from '../../../../../constants';
import { formatMessageTime } from '../../chatHelpers';

interface AdminChatMessageListItemProps {
  itemIndex: number;
  message: IMessage;
  conversationUsersCount: number;
}

const AdminChatMessageListItem: FunctionComponent<AdminChatMessageListItemProps> = ({
  message,
  itemIndex,
  conversationUsersCount,
}) => {
  // Store
  const authState = useAppSelector(getAuthState);

  const authUser = authState.user;
  const messageSender = message.sender;
  const messageStatuses = message.status;
  const isSender = authUser?._id === messageSender._id;
  const dateTime = formatMessageTime(message.createdAt);
  const isGroupChat =
    conversationUsersCount > 1 || conversationUsersCount === 0;

  const senderName = `${messageSender.firstname} ${
    messageSender.lastname || ''
  }`;

  const boxProps: BoxProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  };

  if (isSender) {
    boxProps.justifyContent = 'flex-end';
  }

  const renderStatusIcon = () => {
    const isSeen = messageStatuses.every((item) => item.status === 'SEEN');
    const isSaved = messageStatuses.every((item) => item.status === 'SAVED');
    const isDelivered = messageStatuses.every(
      (item) => item.status === 'DELIVERED'
    );

    if (isSaved) {
      return (
        <DoneIcon
          fontSize="small"
          sx={{
            color: TP_COLORS.gray.darken,
            width: '16px',
            height: '16px',
          }}
        />
      );
    }

    if (isDelivered || isSeen) {
      return (
        <DoneAllIcon
          fontSize="small"
          sx={{
            color: isSeen ? '#0D71D9' : TP_COLORS.gray.darken,
            width: '16px',
            height: '16px',
          }}
        />
      );
    }

    return null;
  };

  return (
    <Box {...boxProps} id={`message-item-${itemIndex}`}>
      <Box
        sx={{
          padding: '12px 14px 6px 14px',
          maxWidth: '220px',
          minWidth: '70px',
          backgroundColor: TP_COLORS.listItemGray.light,
          borderRadius: '20px',
        }}
      >
        {isGroupChat && !isSender && (
          <Typography
            fontSize="12px"
            lineHeight="17px"
            fontWeight="600"
            marginBottom="3px"
            color={TP_COLORS.tutopiyaGreenMain.light}
          >
            {senderName}
          </Typography>
        )}
        <Typography fontSize="14px" lineHeight="17px">
          {message.message}
        </Typography>
        <Box
          display="flex"
          alignItems="flex-end"
          justifyContent="flex-end"
          position="relative"
          bottom="2px"
        >
          <Typography fontSize="10px">{dateTime}</Typography>
          &nbsp;
          {isSender && renderStatusIcon()}
        </Box>
      </Box>
    </Box>
  );
};

export default AdminChatMessageListItem;
